import { Badge } from '@/components/common/Badge'
import { Button } from '@/components/common/Button'
import type { WsConnectionState } from '@/types/websocket'

const STATE_CONFIG: Record<
  WsConnectionState,
  { label: string; variant: 'success' | 'warning' | 'error' | 'brand'; pulse: boolean }
> = {
  CONNECTED: { label: 'Tempo real ativo', variant: 'success', pulse: false },
  CONNECTING: { label: 'Conectando...', variant: 'warning', pulse: true },
  RECONNECTING: { label: 'Reconectando...', variant: 'warning', pulse: true },
  DISCONNECTED: { label: 'Offline', variant: 'error', pulse: false },
  CIRCUIT_OPEN: { label: 'Sem conexao', variant: 'brand', pulse: false },
}

interface Props {
  state: WsConnectionState
  attempt?: number
  onManualReconnect?: () => void
  compact?: boolean
}

export function WsStatusBadge({
  state,
  attempt = 0,
  onManualReconnect,
  compact = false,
}: Props) {
  const config = STATE_CONFIG[state]

  return (
    <div className="flex items-center gap-2">
      <Badge variant={config.variant} dot className={config.pulse ? 'animate-pulse' : undefined}>
        {config.label}
        {state === 'RECONNECTING' && attempt > 0 ? ` (${attempt})` : ''}
      </Badge>
      {state === 'CIRCUIT_OPEN' && onManualReconnect && !compact ? (
        <Button variant="outline" size="sm" onClick={onManualReconnect}>
          Tentar novamente
        </Button>
      ) : null}
    </div>
  )
}
